/**
 * Mesas en el flujo POS: selector, pedido abierto y botones.
 */

function posknMesasAjaxUrl(win) {
	return (
		win.ajaxurl ||
		(win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.ajaxUrl) ||
		'pos-ajax.php'
	);
}

function posknMesasNonce(win) {
	return win.posNonce || (win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.posNonce) || '';
}

function posknMesasTiendaId(win) {
	if (win.posknTiendaSeleccionada && win.posknTiendaSeleccionada.id != null && win.posknTiendaSeleccionada.id !== '') {
		const n = parseInt(win.posknTiendaSeleccionada.id, 10);
		if (!Number.isNaN(n)) return n;
	}
	if (win.posknUserTienda && win.posknUserTienda.id != null && win.posknUserTienda.id !== '') {
		const n = parseInt(win.posknUserTienda.id, 10);
		if (!Number.isNaN(n)) return n;
	}
	return 0;
}

const COCINA_CID_KEY = 'poskn_cocina_client';

function leerCocinaClientGuardado(win, mesaId) {
	try {
		const raw = win.sessionStorage.getItem(COCINA_CID_KEY);
		if (!raw) return '';
		const o = JSON.parse(raw);
		if (o && String(o.mesaId || '') === String(mesaId || '') && o.clientId) {
			return String(o.clientId);
		}
	} catch (e) {
		/* ignore */
	}
	return '';
}

function guardarCocinaClient(win, mesaId, clientId) {
	try {
		win.sessionStorage.setItem(
			COCINA_CID_KEY,
			JSON.stringify({ mesaId: String(mesaId || ''), clientId: String(clientId || ''), ts: Date.now() }),
		);
	} catch (e) {
		/* ignore */
	}
}

function limpiarCocinaClient(win, mesaId) {
	try {
		const raw = win.sessionStorage.getItem(COCINA_CID_KEY);
		if (!raw) return;
		const o = JSON.parse(raw);
		if (!mesaId || String(o.mesaId || '') === String(mesaId || '')) {
			win.sessionStorage.removeItem(COCINA_CID_KEY);
		}
	} catch (e) {
		try {
			win.sessionStorage.removeItem(COCINA_CID_KEY);
		} catch (e2) {
			/* ignore */
		}
	}
}

export function attachMesasPosGlobals(win, $) {
	win.mesasData = win.mesasData || [];

	win.actualizarMesaEnMemoria = function actualizarMesaEnMemoria(mesaId, estado, orderId) {
		if (!win.mesasData || !win.mesasData.length || !mesaId) return;
		const index = win.mesasData.findIndex((m) => parseInt(m.id, 10) === parseInt(mesaId, 10));
		if (index !== -1) {
			win.mesasData[index].estado = estado;
			win.mesasData[index].order_id = orderId;
		}
	};

	win.cerrarModalSelectorMesa = function cerrarModalSelectorMesa() {
		$('#modal-selector-mesa').removeClass('show').attr('style', 'display: none !important;');
	};

	win.mostrarModalSelectorMesa = function mostrarModalSelectorMesa() {
		let html = '<div class="mesas-selector-grid">';
		const mesasData = win.mesasData || [];

		if (mesasData.length === 0) {
			html +=
				'<div style="grid-column: 1/-1; text-align: center; padding: 20px; color: #666;">No hay mesas disponibles. Ve a MESAS para crear una.</div>';
		} else {
			mesasData.forEach((mesa) => {
				const estadoClass = mesa.estado === 'ocupada' ? 'mesa-ocupada' : 'mesa-libre';
				const estadoText = mesa.estado === 'ocupada' ? 'OCUPADA' : 'LIBRE';
				const nombre = mesa.nombre ? `<div class="mesa-nombre-small">${mesa.nombre}</div>` : '';
				const tooltip = mesa.estado === 'ocupada' ? 'title="Clic para recuperar pedido pendiente"' : '';
				const nombreSafe = String(mesa.nombre || '').replace(/'/g, "\\'");
				html += `
                        <div class="mesa-selector-card ${estadoClass}" onclick="seleccionarMesa(${mesa.id}, '${mesa.numero}', '${nombreSafe}')" style="cursor: pointer;" ${tooltip}>
                            <div class="mesa-numero-selector">${mesa.numero}</div>
                            ${nombre}
                            <div class="mesa-capacidad-small">👥 ${mesa.capacidad}</div>
                            <div class="mesa-estado-small">${estadoText}</div>
                            ${mesa.estado === 'ocupada' ? '<div style="font-size: 10px; color: #FF9800; margin-top: 4px;">📋 Pedido pendiente</div>' : ''}
                        </div>
                    `;
			});
		}

		html += '</div>';
		$('#selector-mesas-contenido').html(html);
		const modal = $('#modal-selector-mesa');
		if (modal.length === 0) {
			win.mostrarNotificacion('Error: Modal selector no encontrado', 'error');
			return;
		}
		modal.attr('style', 'display: flex !important;').addClass('show');
	};

	win.cargarMesasParaSelector = function cargarMesasParaSelector() {
		let tiendaId = 0;
		if (win.posknTiendaSeleccionada && win.posknTiendaSeleccionada.id != null && win.posknTiendaSeleccionada.id !== '') {
			tiendaId = parseInt(win.posknTiendaSeleccionada.id, 10);
		} else if (win.posknUserTienda && win.posknUserTienda.id != null && win.posknUserTienda.id !== '') {
			tiendaId = parseInt(win.posknUserTienda.id, 10);
		}
		if (Number.isNaN(tiendaId)) tiendaId = 0;
		$.ajax({
			url: posknMesasAjaxUrl(win),
			type: 'POST',
			data: {
				action: 'poskn_get_mesas',
				nonce: posknMesasNonce(win),
				tienda_id: tiendaId,
			},
				success(response) {
				if (response.success) {
					const md = win.mesasData || (win.mesasData = []);
					md.splice(0, md.length, ...(response.data.mesas || []));
					win.mostrarModalSelectorMesa();
				} else {
					win.mostrarNotificacion(`Error al cargar mesas: ${response.data.message}`, 'error');
				}
			},
			error() {
				win.mostrarNotificacion('Error de conexión al cargar mesas', 'error');
			},
		});
	};

	win.abrirSelectorMesa = function abrirSelectorMesa() {
		if (!win.mesasData || win.mesasData.length === 0) {
			win.cargarMesasParaSelector();
		} else {
			win.mostrarModalSelectorMesa();
		}
	};

	win.cargarPedidoMesa = function cargarPedidoMesa(orderId) {
		$.ajax({
			url: posknMesasAjaxUrl(win),
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'poskn_get_order_items',
				nonce: posknMesasNonce(win),
				order_id: orderId,
				tienda_id: posknMesasTiendaId(win),
			},
			success(response) {
				if (!response || !response.success) {
					const msg =
						(response && response.data && (response.data.message || response.data)) ||
						'No se pudo cargar el pedido de la mesa';
					win.mostrarNotificacion(`Error: ${msg}`, 'error');
					return;
				}
				if (response.data && response.data.items) {
					const st = String((response.data && response.data.status) || '')
						.toLowerCase()
						.replace(/^wc-/, '');
					if (st === 'completed' || st === 'cancelled' || st === 'refunded' || st === 'trash') {
						const carritoDone = win.carrito || (win.carrito = []);
						carritoDone.splice(0, carritoDone.length);
						win.pedidoMesaAbierto = null;
						if (win.mesaSeleccionada) {
							win.actualizarMesaEnMemoria(win.mesaSeleccionada.id, 'libre', null);
							win.mesaSeleccionada.estado = 'libre';
							win.mesaSeleccionada.order_id = null;
						}
						win.actualizarCarrito();
						if (typeof win.actualizarBotonesMesa === 'function') win.actualizarBotonesMesa();
						win.mostrarNotificacion(
							'Ese pedido ya está facturado. La mesa se liberó. No vuelvas a cobrarlo.',
							'success',
						);
						return;
					}
					const carrito = win.carrito || (win.carrito = []);
					const mapped = response.data.items.map((item) => ({
						id: item.product_id,
						originalId: item.product_id,
						name: item.name,
						price: parseFloat(item.price),
						cantidad: parseFloat(item.quantity),
						notas: item.notes || '',
						variacionId: item.variation_id || null,
						ckn: item.ckn || null,
						cknNames: item.ckn_names || [],
						enCocina: true,
					}));
					carrito.splice(0, carrito.length, ...mapped);

					win.pedidoMesaAbierto = {
						order_id: orderId,
						status: response.data.status,
					};
					win.actualizarMesaEnMemoria(
						win.mesaSeleccionada ? win.mesaSeleccionada.id : null,
						'ocupada',
						orderId
					);
					win.actualizarCarrito();

					if (response.data.cliente) {
						win.clienteSeleccionado = response.data.cliente;
						if (typeof win.mostrarClienteSeleccionado === 'function') {
							win.mostrarClienteSeleccionado();
						}
					} else if (typeof win.resetClienteSeleccion === 'function') {
						win.resetClienteSeleccion(true);
					}

					const totalProductos = carrito.length;
					const mensaje =
						totalProductos === 1
							? 'Pedido recuperado: 1 producto en espera. Puedes agregar más o cerrar la cuenta.'
							: `Pedido recuperado: ${totalProductos} productos en espera. Puedes agregar más o cerrar la cuenta.`;
					win.mostrarNotificacion(mensaje, 'success');
				}
			},
			error(xhr) {
				let msg = 'Error al cargar pedido de la mesa';
				try {
					const parsed = xhr && xhr.responseJSON;
					if (parsed && parsed.data) {
						msg = typeof parsed.data === 'string' ? parsed.data : parsed.data.message || msg;
					}
				} catch (eLoad) {
					/* ignore */
				}
				win.mostrarNotificacion(msg, 'error');
			},
		});
	};

	win.seleccionarMesa = function seleccionarMesa(id, numero, nombre) {
		$.ajax({
			url: posknMesasAjaxUrl(win),
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'poskn_get_mesa_info',
				nonce: posknMesasNonce(win),
				mesa_id: id,
				tienda_id: posknMesasTiendaId(win),
			},
			success(response) {
				if (response.success) {
					const mesaInfo = response.data.mesa;
					win.mesaSeleccionada = {
						id,
						numero,
						nombre: nombre || numero,
						order_id: mesaInfo.order_id || null,
						estado: mesaInfo.estado || 'libre',
					};
					if (String(win._posknCocinaClientMesaId || '') !== String(id)) {
						win._posknCocinaClientId = null;
						win._posknCocinaClientMesaId = null;
					}

					if (mesaInfo.order_id && mesaInfo.estado === 'ocupada') {
						win.cargarPedidoMesa(mesaInfo.order_id);
					} else {
						const carrito = win.carrito || (win.carrito = []);
						carrito.splice(0, carrito.length);
						win.pedidoMesaAbierto = null;
						win.actualizarCarrito();
					}

					$('#mesa-badge').text(numero).show();
					$('#mesa-nombre-compacto').text(win.mesaSeleccionada.nombre);
					$('#mesa-seleccionada-compacto').show();
					$('#mesa-indicador-carrito').show();
					$('#mesa-numero-carrito').text(numero);
					if (typeof win.seleccionarTipoServicio === 'function') win.seleccionarTipoServicio('comer');

					win.cerrarModalSelectorMesa();

					win.mostrarNotificacion(
						`Mesa ${numero} seleccionada. Los productos se agregarán a esta mesa.`,
						'success'
					);
					setTimeout(() => win.actualizarBotonesMesa(), 100);
				} else {
					const msg =
						(response && response.data && (response.data.message || response.data)) ||
						'Error al cargar información de la mesa';
					win.mostrarNotificacion(`Error: ${msg}`, 'error');
				}
			},
			error(xhr) {
				let msg = 'Error al cargar información de la mesa';
				try {
					const parsed = xhr && xhr.responseJSON;
					if (parsed && parsed.data) {
						msg = typeof parsed.data === 'string' ? parsed.data : parsed.data.message || msg;
					}
				} catch (eSel) {
					/* ignore */
				}
				win.mostrarNotificacion(msg, 'error');
			},
		});
	};

	win.actualizarBotonesMesa = function actualizarBotonesMesa() {
		// Solo limpiar vínculo de mesa. NUNCA borrar pedido Knia/WhatsApp (sin_mesa).
		const abierto = win.pedidoMesaAbierto;
		const esKniaOExterno =
			abierto &&
			(abierto.sin_mesa === true ||
				abierto.canal === 'knia' ||
				abierto.canal === 'whatsapp');
		if (!win.mesaSeleccionada && abierto && !esKniaOExterno) {
			win.pedidoMesaAbierto = null;
		}

		const carrito = win.carrito || [];
		if (win.mesaSeleccionada && carrito.length > 0) {
			if (win.pedidoMesaAbierto && win.pedidoMesaAbierto.order_id) {
				$('#btn-enviar-cocina').text('🔄 Actualizar Cocina').show();
			} else {
				$('#btn-enviar-cocina').text('🍳 Enviar a Cocina').show();
			}
		} else {
			$('#btn-enviar-cocina').hide();
		}

		const esCierreCuenta =
			carrito.length > 0 &&
			((win.mesaSeleccionada && win.pedidoMesaAbierto && win.pedidoMesaAbierto.order_id) ||
				(win.pedidoMesaAbierto &&
					win.pedidoMesaAbierto.order_id &&
					(win.pedidoMesaAbierto.sin_mesa || win.pedidoMesaAbierto.canal === 'knia')));

		if (esCierreCuenta) {
			$('#btn-pagar-icon').text('💰');
			$('#btn-pagar-text').text('CERRAR CUENTA');
			$('#btn-pagar').prop('disabled', false);
		} else {
			$('#btn-pagar-icon').text('💳');
			$('#btn-pagar-text').text('IR A PAGAR');
		}
	};

	win._limpiarMesaInterno = function _limpiarMesaInterno(codigoLiberar) {
		if (win.mesaSeleccionada && win.mesaSeleccionada.estado === 'ocupada' && win.mesaSeleccionada.id) {
			const codigoYaValidado = codigoLiberar && String(codigoLiberar).trim().length > 0;
			if (!codigoYaValidado && !confirm('¿Deseas liberar esta mesa? Esto cambiará su estado a libre.')) {
				return;
			}
			const dataLiberar = {
				action: 'poskn_liberar_mesa',
				nonce: posknMesasNonce(win),
				id: win.mesaSeleccionada.id,
				tienda_id:
					win.posknTiendaSeleccionada && win.posknTiendaSeleccionada.id != null && win.posknTiendaSeleccionada.id !== ''
						? parseInt(win.posknTiendaSeleccionada.id, 10) || 0
						: 0,
			};
			if (codigoLiberar) dataLiberar.codigo_liberar = codigoLiberar;

			$.ajax({
				url: posknMesasAjaxUrl(win),
				type: 'POST',
				dataType: 'json',
				data: dataLiberar,
				success(response) {
					if (response.success) {
						win.pedidoMesaAbierto = null;
						const carrito = win.carrito || (win.carrito = []);
						carrito.splice(0, carrito.length);
						win.actualizarCarrito();

						const mesaId = win.mesaSeleccionada.id;
						win.mesaSeleccionada = null;
						$('#mesa-badge').hide();
						$('#mesa-seleccionada-compacto').hide();
						$('#mesa-indicador-carrito').hide();
						win.actualizarMesaEnMemoria(mesaId, 'libre', null);
						win.actualizarBotonesMesa();
						if (typeof win.cargarMesas === 'function') win.cargarMesas();
						win.mostrarNotificacion('Mesa liberada exitosamente', 'success');
					} else {
						win.mostrarNotificacion(response.data.message || 'Error al liberar la mesa', 'error');
					}
				},
				error() {
					win.mostrarNotificacion('Error de conexión al liberar la mesa', 'error');
				},
			});
		} else {
			win.pedidoMesaAbierto = null;
			win.mesaSeleccionada = null;
			$('#mesa-badge').hide();
			$('#mesa-seleccionada-compacto').hide();
			$('#mesa-indicador-carrito').hide();
			win.actualizarBotonesMesa();
			win.mostrarNotificacion(
				'Mesa deseleccionada. Puedes seleccionar otra mesa o hacer pedidos sin mesa.',
				'success'
			);
		}
	};

	win.limpiarUiTrasEnviarCocina = function limpiarUiTrasEnviarCocina(orderId) {
		const oid = parseInt(orderId || win.ultimoOrderIdEnviado || 0, 10) || 0;
		const carrito = win.carrito || (win.carrito = []);
		carrito.forEach((item) => {
			item.enCocina = true;
		});
		if (win.mesaSeleccionada && win.mesaSeleccionada.id) {
			if (oid > 0) {
				win.mesaSeleccionada.estado = 'ocupada';
				win.mesaSeleccionada.order_id = oid;
				win.pedidoMesaAbierto = { order_id: oid, status: 'pending' };
				win.actualizarMesaEnMemoria(win.mesaSeleccionada.id, 'ocupada', oid);
			}
		} else {
			carrito.splice(0, carrito.length);
			win.pedidoMesaAbierto = null;
		}
		win.actualizarCarrito();
		win.actualizarBotonesMesa();
	};

	win.limpiarMesa = function limpiarMesa() {
		const mesaOcupada =
			win.mesaSeleccionada && win.mesaSeleccionada.estado === 'ocupada' && win.mesaSeleccionada.id;
		if (mesaOcupada && win.posknCodigoLimpiar && String(win.posknCodigoLimpiar).trim().length > 0) {
			win.posknPedirCodigo('Código para liberar mesa').then((codigo) => {
				if (codigo === false) return;
				win._limpiarMesaInterno(codigo);
			});
			return;
		}
		win._limpiarMesaInterno(null);
	};

	win.enviarACocina = function enviarACocina() {
		const carrito = win.carrito || [];
		if (!carrito.length) {
			win.mostrarNotificacion('El carrito está vacío', 'error');
			return;
		}
		if (!win.mesaSeleccionada) {
			win.mostrarNotificacion('Debes seleccionar una mesa primero', 'error');
			return;
		}
		win.POSKN.api
			.getCajaStatus(15000)
			.then((response) => {
				if (response.success && response.data.estado === 'abierta') {
					win.enviarPedidoACocina();
				} else {
					win.mostrarNotificacion('❌ Debes abrir una caja antes de enviar a cocina', 'error');
					if (confirm('¿Deseas abrir una caja ahora?') && typeof win.mostrarModuloCaja === 'function') {
						win.mostrarModuloCaja();
					}
				}
			})
			.catch(() => {
				win.mostrarNotificacion('Error al verificar estado de caja', 'error');
			});
	};

	win.enviarPedidoACocina = function enviarPedidoACocina() {
		if (typeof win.requireRepartidorSiDelivery === 'function' && !win.requireRepartidorSiDelivery()) {
			return;
		}
		const carrito = win.carrito || [];
		const totCocina =
			typeof win.posknTotalesDesdeCarrito === 'function' ? win.posknTotalesDesdeCarrito() : null;
		const subtotalUsd = totCocina
			? totCocina.subtotalUsd
			: carrito.reduce((sum, item) => sum + item.price * item.cantidad, 0);
		const descuentoUsd = totCocina ? totCocina.descuentoUsd : win.calcularDescuento(subtotalUsd);
		const deliveryUsd = totCocina
			? totCocina.deliveryUsd
			: typeof win.getDeliveryFeeUsd === 'function'
				? win.getDeliveryFeeUsd()
				: 0;
		const totalUsd = totCocina ? totCocina.totalUsd : subtotalUsd - descuentoUsd + deliveryUsd;
		const totalBs = totCocina ? totCocina.totalBs : totalUsd * (win.TASA_DOLAR || 1);
		const esActualizacionMesa = !!win.pedidoMesaAbierto;
		const itemsParaCocina = esActualizacionMesa ? carrito : carrito.filter((item) => !item.enCocina);

		if (!esActualizacionMesa && !itemsParaCocina.length) {
			$('#btn-enviar-cocina').prop('disabled', false).text('🍳 Enviar a Cocina');
			win.mostrarNotificacion('No hay nuevos productos para enviar a cocina.', 'info');
			return;
		}

		const descuentoActual = win.descuentoActual || { tipo: 'porcentaje', valor: 0, activo: false };
		const modoServicio = win.modoServicioSeleccionado || 'comer';
		const pedidoExistenteId =
			win.mesaSeleccionada && win.pedidoMesaAbierto && win.pedidoMesaAbierto.order_id
				? win.pedidoMesaAbierto.order_id
				: null;
		let clientIdCocina = '';
		const mesaIdCocina = win.mesaSeleccionada && win.mesaSeleccionada.id ? String(win.mesaSeleccionada.id) : '';
		const cidGuardado = leerCocinaClientGuardado(win, mesaIdCocina);
		if (pedidoExistenteId) {
			clientIdCocina = `cocina-${pedidoExistenteId}`;
		} else if (win._posknCocinaClientId && String(win._posknCocinaClientMesaId || '') === mesaIdCocina) {
			clientIdCocina = win._posknCocinaClientId;
		} else if (cidGuardado && String(cidGuardado).indexOf('cocina-mesa-') !== 0) {
			clientIdCocina = cidGuardado;
		} else if (win.crypto && typeof win.crypto.randomUUID === 'function') {
			clientIdCocina = `pos-enviar-${win.crypto.randomUUID()}`;
		} else {
			clientIdCocina = `pos-enviar-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
		}
		win._posknCocinaClientId = clientIdCocina;
		win._posknCocinaClientMesaId = mesaIdCocina;
		guardarCocinaClient(win, mesaIdCocina, clientIdCocina);
		try {
			win.localStorage.setItem(
				'pos_pedido_enviando',
				JSON.stringify({
					pedidoCompleto: {
						client_pedido_id: clientIdCocina,
						numero: pedidoExistenteId ? `#mesa-${pedidoExistenteId}` : `#env-${Date.now()}`,
						items: itemsParaCocina,
						mesa: win.mesaSeleccionada || null,
						tienda: win.posknTiendaSeleccionada || null,
						pedido_existente: pedidoExistenteId || null,
						cerrar_cuenta: false,
						enviar_cocina: true,
						metodosPago: [],
						total: { usd: totalUsd, bs: totalBs },
						estado: 'pending',
					},
					numeroPedido: pedidoExistenteId ? `#mesa-${pedidoExistenteId}` : `#env-local`,
					totalUsd,
					totalBs,
					client_pedido_id: clientIdCocina,
					timestamp: Date.now(),
				}),
			);
		} catch (eEnvCocina) {
			/* ignore */
		}
		const pedidoData = {
			items: itemsParaCocina.map((item) => ({
				id: item.id,
				originalId: item.originalId,
				name: item.name,
				price: item.price,
				cantidad: item.cantidad,
				notas: item.notas,
				variacionId: item.variacionId,
				ckn: item.ckn,
				cknNames: item.cknNames,
			})),
			cliente: win.clienteSeleccionado,
			mesa: win.mesaSeleccionada,
			tienda: win.posknTiendaSeleccionada,
			tipo_servicio: modoServicio,
			tipo_servicio_label:
				typeof win.getTipoServicioLabel === 'function' ? win.getTipoServicioLabel(modoServicio) : modoServicio,
			delivery_fee: deliveryUsd,
			repartidor: typeof win.getRepartidorPedido === 'function' ? win.getRepartidorPedido() : null,
			pedido_existente: pedidoExistenteId,
			client_pedido_id: clientIdCocina,
			subtotal: subtotalUsd,
			descuento: { tipo: descuentoActual.tipo, valor: descuentoActual.valor, monto: descuentoUsd },
			total: { usd: totalUsd, bs: totalBs },
			metodosPago: [],
			tasa: win.TASA_DOLAR || 1,
			enviar_cocina: true,
			cerrar_cuenta: false,
			actualizar_completo: esActualizacionMesa,
		};

		$('#btn-enviar-cocina').prop('disabled', true).text('Enviando...');

		const numeroCocinaOutbox = pedidoData.pedido_existente
			? `#mesa-${pedidoData.pedido_existente}`
			: `#env-${Date.now()}`;
		if (typeof win.guardarEnColaPendienteSubir === 'function') {
			const okOutboxCocina = win.guardarEnColaPendienteSubir(
				{
					client_pedido_id: clientIdCocina,
					numero: numeroCocinaOutbox,
					items: pedidoData.items,
					mesa: pedidoData.mesa || null,
					tienda: pedidoData.tienda || null,
					tipo_servicio: pedidoData.tipo_servicio,
					delivery_fee: pedidoData.delivery_fee,
					pedido_existente: pedidoData.pedido_existente || null,
					cerrar_cuenta: false,
					enviar_cocina: true,
					actualizar_completo: !!pedidoData.actualizar_completo,
					metodosPago: [],
					total: pedidoData.total,
					tasa: pedidoData.tasa,
					subtotal: pedidoData.subtotal,
					descuento: pedidoData.descuento,
					cliente: pedidoData.cliente || null,
					estado: 'pending',
					fecha: new Date().toLocaleString(),
				},
				numeroCocinaOutbox,
				totalUsd,
				totalBs,
				clientIdCocina,
			);
			if (!okOutboxCocina) {
				$('#btn-enviar-cocina').prop('disabled', false).text('🍳 Enviar a Cocina');
				win.mostrarNotificacion(
					'No se pudo guardar el envío a cocina. El carrito se mantiene para que no se pierda. Reintenta.',
					'error',
				);
				return;
			}
			if (typeof win.marcarColaOutboxEstado === 'function') {
				win.marcarColaOutboxEstado(clientIdCocina, 'sending');
			}
		}

		$.ajax({
			url: posknMesasAjaxUrl(win),
			method: 'POST',
			dataType: 'json',
			cache: false,
			data: {
				action: 'pos_enviar_cocina',
				nonce: posknMesasNonce(win),
				pedido_data: JSON.stringify(pedidoData),
				client_pedido_id: clientIdCocina,
				_t: Date.now(),
			},
			success(response) {
				$('#btn-enviar-cocina').prop('disabled', false).text('🍳 Enviar a Cocina');
				const dataCocina = response && response.data;
				const isAckCocina =
					typeof win.posknRespuestaEsAckPedido === 'function'
						? win.posknRespuestaEsAckPedido(dataCocina)
						: !!(dataCocina && dataCocina.ack === true && dataCocina.order_id);
				if (!response || !response.success) {
					win.mostrarNotificacion(
						`Error: ${(dataCocina && dataCocina.message) || 'Error desconocido'}`,
						'error',
					);
					return;
				}
				if (!isAckCocina && !(dataCocina && dataCocina.order_id)) {
					win.mostrarNotificacion(
						`Error: ${(dataCocina && dataCocina.message) || 'Sin confirmación del servidor'}`,
						'error',
					);
					return;
				}
				const esActualizacion = !!pedidoData.pedido_existente;
				let orderId = null;
				if (dataCocina && dataCocina.order_id) {
					orderId = parseInt(dataCocina.order_id, 10);
				} else if (pedidoData.pedido_existente) {
					orderId = parseInt(pedidoData.pedido_existente, 10);
				}
				if (!orderId) {
					win.mostrarNotificacion('Error: No se pudo obtener el ID del pedido', 'error');
					return;
				}
				win.ultimoOrderIdEnviado = orderId;
				win._posknCocinaClientId = null;
				win._posknCocinaClientMesaId = null;
				limpiarCocinaClient(win, mesaIdCocina);
				try {
					win.localStorage.removeItem('pos_pedido_enviando');
				} catch (eClr) {
					/* ignore */
				}
				if (typeof win.quitarDeColaPendientesSubir === 'function') {
					win.quitarDeColaPendientesSubir(clientIdCocina);
				}
				if (pedidoData.mesa && pedidoData.mesa.id) {
					win.actualizarMesaEnMemoria(pedidoData.mesa.id, 'ocupada', orderId);
				}
				win.limpiarUiTrasEnviarCocina(orderId);
				setTimeout(() => {
					if (typeof win.mostrarModalImprimirComanda === 'function') {
						win.mostrarModalImprimirComanda(orderId, pedidoData.mesa, esActualizacion);
					}
				}, 300);
			},
			error(xhr, status) {
				$('#btn-enviar-cocina').prop('disabled', false).text('🍳 Enviar a Cocina');
				let msgServidor = '';
				try {
					const parsed = xhr && xhr.responseJSON;
					if (parsed && parsed.data) {
						msgServidor = typeof parsed.data === 'string' ? parsed.data : (parsed.data.message || '');
					}
				} catch (eParse) {
					/* ignore */
				}
				const codigo = xhr && xhr.status ? parseInt(xhr.status, 10) : 0;
				if (codigo >= 400 && codigo < 500 && msgServidor) {
					if (typeof win.marcarColaOutboxEstado === 'function') {
						win.marcarColaOutboxEstado(clientIdCocina, 'failed_business', {
							_error_servidor: msgServidor,
						});
					}
					win.mostrarNotificacion(`Error: ${msgServidor}`, 'error');
					return;
				}
				const esRed =
					status === 'timeout' ||
					status === 'abort' ||
					codigo === 0 ||
					codigo >= 500 ||
					(typeof win.posknEsErrorRed === 'function' && win.posknEsErrorRed(xhr, status));
				if (!esRed && msgServidor) {
					win.mostrarNotificacion(`Error: ${msgServidor}`, 'error');
					return;
				}
				if (typeof win.marcarColaOutboxEstado === 'function') {
					win.marcarColaOutboxEstado(clientIdCocina, 'queued');
				}
				win.mostrarNotificacion(
					'Sin conexión. El pedido quedó en "Pendientes de subir" con el mismo identificador para no duplicarlo. No se cierra caja hasta que suba.',
					'warning',
				);
			},
		});
	};
}
